import { useMemo } from "react";

import { getAlertsDefaultDuration, getAlertsAvailableDates } from "../utils";

export const useAlertsDefaultDuration = () => {
    const { minDate, maxDate } = getAlertsAvailableDates();

    return useMemo(() => {
        if (!minDate || !maxDate) {
            return "";
        }

        return getAlertsDefaultDuration({ minDate, maxDate });
    }, [minDate, maxDate]);
};
